import { TFunction } from 'i18next'
import { format, parseISO, startOfDay } from '@e3dc-react/shell/Libs/date'

export type RfidCardStatus = 'expired' | 'valid' | 'unlimited'

/**
 * WORKAROUND FOR NOW: If the user sets now date (valid option)
 * the backend defaults to the date 3000-01-01. Thus, this corresponds to unlimited validity of the card.
 */
export const RFID_UNLIMITED_EXPIRATION_DATE = '3000-01-01T00:00:00.000Z'

/** Returns a status for the rfid-expiration-date (unlimited, expired or valid) */
export const getRfidChipStatus = (expirationDate: string): RfidCardStatus => {
  if (expirationDate === RFID_UNLIMITED_EXPIRATION_DATE) return 'unlimited'

  if (startOfDay(new Date()) > startOfDay(parseISO(expirationDate))) return 'expired'

  return 'valid'
}

/** Returns the label for the status according to the RfidCardStatus */
export const getRfidChipLabel = (status: RfidCardStatus, expirationDate: string, t: TFunction): string => {
  if (status === 'valid') return `${t('installation.rfidCardSimple.label')} ${format(parseISO(expirationDate), 'dd.MM.yyyy')}`

  if (status === 'unlimited') return t('installation.rfidCardSimple.status.unlimited')

  return t('installation.rfidCardSimple.status.expired')
}

type RfidChipColor = { color: string; bgcolor: string }
const RFID_CHIP_COLORS: Record<RfidCardStatus, RfidChipColor> = {
  expired: { color: '#BF360C', bgcolor: '#FFCCBC' },
  unlimited: { color: '#004673', bgcolor: '#BEE7FF' },
  valid: { color: '#004673', bgcolor: '#BEE7FF' },
}
export const getRfidChipColors = (status: RfidCardStatus): RfidChipColor => RFID_CHIP_COLORS[status]
